import { getUrl } from "./helper";
import { authedFunction } from "../session";

export const infoActions = {
	getInfoPages: (site) => {
		return authedFunction({
			method: "GET",
			url: getUrl("info", "pages/get", { site, getAll: true }),
		});
	},
	getInfoPage: (id) => {
		return authedFunction({
			method: "GET",
			url: getUrl("info", `pages/get/${id}`),
		});
	},
	addInfoPage: (site, title, text, order, attachments, notify, fields) => {
		return authedFunction({
			method: "POST",
			url: getUrl("info", "pages/add"),
			data: {
				site,
				title,
				text,
				order,
				attachments,
				notify,
				fields,
				parentId: fields && fields.parentId,
				type: "page",
			},
		});
	},
	/**
	 * Adds a new info folder.
	 * @async
	 * @param {{ site: string, name: string }} params - The folder details.
	 * @returns {Promise<void>} Resolves when the folder is created.
	 */
	addInfoFolder: async ({ site, name }) => {
		return authedFunction({
			method: "POST",
			url: getUrl("info", "pages/add"),
			data: {
				site,
				title: name,
				type: "folder",
			},
		});
	},
	editInfoPage: (site, id, title, text, order, attachments, notify, fields) => {
		return authedFunction({
			method: "POST",
			url: getUrl("info", "pages/edit"),
			data: {
				site,
				id,
				title,
				text,
				order,
				attachments,
				notify,
				fields,
			},
		});
	},
	deleteInfoPage: (site, id) => {
		return authedFunction({
			method: "POST",
			url: getUrl("info", "pages/remove"),
			data: {
				site,
				id,
			},
		});
	},
	changeInfoPageOrder: async (site, changes) => {
		return authedFunction({
			method: "POST",
			url: getUrl("info", "pages/order"),
			data: {
				site,
				changes,
			},
		});
	},
	getWelcomePages: (site) => {
		return authedFunction({
			method: "GET",
			url: getUrl("info", "welcome/get", { site }),
		});
	},
	getWelcomePage: (id) => {
		return authedFunction({
			method: "GET",
			url: getUrl("info", `welcome/get/${id}`),
		});
	},
	addWelcomePage: (
		site,
		title,
		text,
		images,
		audienceType,
		audienceTypeSelection,
		order,
	) => {
		return authedFunction({
			method: "POST",
			url: getUrl("info", "welcome/add"),
			data: {
				site,
				title,
				text,
				images,
				audienceType,
				audienceTypeSelection,
				order,
			},
		});
	},
	editWelcomePage: (
		site,
		id,
		title,
		text,
		images,
		audienceType,
		audienceTypeSelection,
	) => {
		return authedFunction({
			method: "POST",
			url: getUrl("info", "welcome/edit"),
			data: {
				site,
				id,
				title,
				text,
				images,
				audienceType,
				audienceTypeSelection,
			},
		});
	},
	deleteWelcomePage: (site, id) => {
		return authedFunction({
			method: "POST",
			url: getUrl("info", "welcome/remove"),
			data: {
				site,
				id,
			},
		});
	},
	changeWelcomePageOrder: (site, changes) => {
		return authedFunction({
			method: "POST",
			url: getUrl("info", "welcome/order"),
			data: {
				site,
				changes,
			},
		});
	},
	copyWelcomePage: (site, source) => {
		return authedFunction({
			method: "POST",
			url: getUrl("info", "welcome/copy"),
			data: {
				site,
				source,
			},
		});
	},
	getCurrentWeather: async (site) => {
		return authedFunction({
			method: "GET",
			url: getUrl("info", "weather/current", { site }),
		});
	},
	getWeatherCity: async (query) => {
		return authedFunction({
			method: "GET",
			url: getUrl("info", "weather/city", { q: query }),
		});
	},
	getWeatherCityFromGooglePlace: async (googlePlaceId, sessionToken) => {
		return authedFunction({
			method: "GET",
			url: getUrl("info", "weather/city", { googlePlaceId, sessionToken }),
		});
	},
	placeAutocomplete: async (query, token) => {
		return authedFunction({
			method: "GET",
			url: getUrl("info", "places/autocomplete", { q: query, token }),
		});
	},
};
